<template>
    <div class="car-wrap">
        <!-- 引入公共头部 -->
        <dg-header title="购物车"></dg-header>
        <!-- 编辑 -->
        <div class="classify-edit-btn" v-if="carData.length > 0">
            <span class="edit-btn" @click="editCar">{{settlementShow ?'编辑' : '完成'}}</span>
        </div>
        <div class="car-content-wrap">
            <!-- 购物车商品列表 -->
            <car-item
                @showPopups="showPopups"
                @handlerCarList="handlerCarList"
                :carList="carData"
                :settlementShow="settlementShow"
                :fullDetetShow="fullDetetShow"
            ></car-item>
        </div>
        <!-- 重新选择套餐弹框 -->
        <car-popup ref="popups" :detailList="detailList" :type="type" @updateCarList="updateCarList"></car-popup>
        <!-- 引入公共footer -->
        <common-footer></common-footer>
    </div>
</template>
<script>
import DgHeader from "@/components/header";
import CarItem from "./components/product-item";
import CarPopup from "@/components/cart-popup";
import CommonFooter from "@/components/footer";
import api from "@/server";
export default {
    data() {
        return {
            isChecked: "",
            // 全选状态
            AllChecked: false,
            // 点击编辑，合计金额隐藏
            settlementShow: true,
            // 点击编辑,删除按钮显示
            fullDetetShow: false,
            detailList: [],
            carData: [],
            type: ''
        };
    },
    components: {
        DgHeader,
        CarItem,
        CarPopup,
        CommonFooter
    },
    activated() {
        // 获取购物车列表
        if (localStorage.getItem('carList')) {
            this.carData = JSON.parse(localStorage.getItem('carList'));
        } else {
            this.carData = [];
        }
    },
    methods: {
        // 点击编辑按钮
        editCar() {
            this.settlementShow = !this.settlementShow;
            this.fullDetetShow = !this.fullDetetShow;
        },
        // 点击结算跳转至确定订单页
        jumpConfirmOrder() {
            this.$router.push({ path: "/confirm-order" });
        },
        /*
          funxtion 重新选择套餐，弹出弹框
          @item 选中时子组件传出的当前购物车数据
          @index 选中时传出的子组件当前数据的下标，用来设置本地数据
        */
        showPopups(item, index) {
            api.detailData({
                id: item.commId
            }).then(res => {
                if (res.code === 200 && res.data.resullt) {
                    let data = res.data.resullt[0];
                    data.comImage[0].url = item.comImageCar;
                    data.count = item.count;
                    data.carId = item.id;
                    data.dataIndex = index;
                    data.attribute.forEach((attrItem, i) => {
                        attrItem.value.forEach(attr => {
                            if (item.attributeCar[i].value === attr.itemName) {
                                attr.checked = true
                            }
                        })
                    });
                    this.detailList = data;
                    this.type = 'edit';
                    this.$refs.popups.open();
                } else {
                    this.detailList = [];
                    this.$toast('获取商品信息失败')
                }
            }).catch(() => { })
        },
        // 编辑购物车成功后触发监听回调，重新更新本地数据
        updateCarList() {
            this.carData = JSON.parse(localStorage.getItem('carList'));
        },
        handlerCarList() {
            this.carData = JSON.parse(localStorage.getItem('carList'));
        }
    },
};
</script>
<style lang="scss">
.car-wrap {
    width: 100%;
    height: auto;
    background: $bg01;
    padding-top: 88px;
    .fs24 {
        font-size: 24px;
    }
    .classify-edit-btn {
        width: 100%;
        max-width: 750px;
        height: 80px;
        line-height: 80px;
        background: $fc02;
        text-align: right;
        padding: 0 30px;
        box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.08);
        position: fixed;
        z-index: 666;
        .edit-btn {
            font-size: 28px;
            color: $fc03;
            display: inline-block;
        }
    }
    .car-content-wrap {
        margin-top: 80px;
        width: 100%;
        height: auto;
        padding: 0 0 200px 0;
    }
    .count-wrap {
        width: 100%;
        max-width: 750px;
        height: 100px;
        background: $fc02;
        position: fixed;
        bottom: 103px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px 0 60px;
        .count-wrap-checkbox {
            font-size: 30px;
            color: $fc03;
        }
        .settlement {
            display: flex;
            align-items: center;
            .settlement-total {
                text-align: right;
            }
            .amount-p {
                font-size: 24px;
                color: $fc06;
            }
            .amount-num {
                font-size: 30px;
                color: $fc04;
            }
            // .settlement-total-btn {
            //   width: 220px;
            //   height: 80px;
            //   line-height: 80px;
            //   text-align: center;
            //   font-size: 30px;
            //   background: $btn01;
            //   border-radius: 60px;
            //   color: $fc02;
            //   border: none;
            //   margin-left: 24px;
            //   &:active {
            //     background: $btnHover01;
            //   }
            // }
        }
        .settlement-total-btn,
        .car-detet-btn {
            width: 220px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            font-size: 30px;
            background: $btn01;
            border-radius: 60px;
            color: $fc02;
            border: none;
            margin-left: 24px;
            &:active {
                background: $btnHover01;
            }
        }
    }
}
</style>


